<template>
  <div>
    <div class="bg-primary">
      <div class="max-w-5xl mx-auto px-4">
        <loader v-if="isLoading"></loader>
        <div v-else>
          <div class="text-center text-white py-5">
            <div class="w-full mt-3">
              <div>
                <h3>{{ user.firstName }} {{ user.lastName }}</h3>
              </div>
              <div>
                <a href="#" @click.prevent="openEditModal()" class="text-white underline hover:opacity-80 transition-opacity">
                  Edit profile
                </a>
              </div>
            </div>
            <profile-edit :item="user" ref="modal" @update="update"></profile-edit>
          </div>
        </div>
      </div>
    </div>
    <br>

    <div class="max-w-5xl mx-auto px-4">
      <div class="flex flex-wrap">
        <div class="w-full">
          <div class="rounded-lg border border-border">
            <div class="p-3 py-5 text-center" v-if="activeSubscription">
              <h2 class="text-2xl font-semibold">My subscriptions</h2>
              <p>You are paying {{ toCurrency(activeSubscription.priceData.unit_amount, activeSubscription.priceData.currency) }} per {{ activeSubscription.priceData.interval }}.</p>
              <a href="#" class="rounded-3xl bg-primary border-none px-[30px] py-3 text-base text-white tracking-[0.03em] hover:opacity-85 transition-opacity inline-block" @click.prevent="redirect()">Customer portal</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfileEdit from './ProfileEditModal'

export default {
  components: {
    profileEdit: ProfileEdit
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isLoading: state => state.auth.loading,
      activeSubscription: state => state.auth.activeSubscription
    })
  },
  methods: {
    toCurrency (amount, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format((amount / 100).toFixed(2))
    },
    openEditModal () {
      this.editGroup = null
      setTimeout(() => {
        this.$refs.modal.toggleModal()
      }, 100)
    },
    update () {
      this.$store.dispatch('GET_USER')
      this.$refs.modal.hideModal()
    },
    redirect () {
      this.$store.dispatch('REDIRECT_TO_CUSTOMER_PORTAL')
    }
  },
  mounted () {
    this.$store.dispatch('SET_LOADING', false)

    setTimeout(() => {
      this.show = false
    }, 2000)
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
    this.$store.dispatch('GET_USER')
  }
}
</script>